<template>
  <div>
      <iframe :src="url" style="border: none" :height="height + 30" width="100%"></iframe>
  </div>
</template>

<script>
import $http from '../request';
export default {
  props: {
    sxtbm: {
      type: String,
      default: '',
    },
    startToPlay: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 200,
    }
  },
  data() {
    return {
      tenantId: sessionStorage.getItem("tenantId"),
      url: ''
    };
  },
  watch: {

  },
  created() {

  },
  mounted() {
     this.getVideoUrl();
  },
  methods: {
    getVideoUrl() {
      $http({
        url: "hls2Video/realConfig",
        method: 'get',
      }).then((res) => {
        let videoUrl = res.data.videoUrl;
        this.url = videoUrl + `ffmpegPlay.html?tenantId=${this.tenantId}&key=${this.sxtbm}&height=${this.height + 'px'}`
        // this.url =  `http://218.87.193.93:9971/video/ffmpegPlay.html?tenantId=lyhg&key=01&height=340px`
      })
    }
  },
  destroyed() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/video/AliPlayerHls2.vue